/**
 * JavascriptQualifier
 * The qualifier list sends each function string as an array entry (EvaluatedObject from config).
 * Executes each function and returns { key: fnString, value: executedResult }.
 *
 * The API stores item.Key → JavascriptKey and item.Value → JavascriptValue (last item wins).
 * CheckJavascriptCondition uses JavascriptValue directly against rule.Value with the qualifier operator.
 * Since the API matches by value only (not key), each function result is sent separately
 * so the API processes the one matching the current rule's EvaluatedObject.
 */
export class JavascriptQualifier {
    constructor() {
        this.key = "Javascript";
    }
    async process(config) {
        const entries = Array.isArray(config) ? config : [];
        const results = [];
        for (const fnString of entries) {
            if (!fnString || typeof fnString !== 'string')
                continue;
            results.push({
                key: fnString, // item.Key → JavascriptKey (function string as identifier)
                value: this.execute(fnString) // item.Value → JavascriptValue (executed result)
            });
        }
        return results;
    }
    execute(fnString) {
        try {
            // eslint-disable-next-line no-new-func
            const wrapped = new Function(`
                ${fnString}
                const match = (${JSON.stringify(fnString)}).match(/function\\s+(\\w+)/);
                return match ? eval(match[1] + '()') : undefined;
            `);
            const result = wrapped();
            if (result === undefined || result === null)
                return "";
            if (Array.isArray(result)) {
                return result
                    .filter(item => item !== undefined && item !== null)
                    .map(item => String(item).toLowerCase().trim())
                    .join(",");
            }
            return String(result).toLowerCase();
        }
        catch (_a) {
            return "";
        }
    }
}
